import React from 'react';
export type ChartPoint = {
  key: string;
  value: number;
  color: string;
};
export type ChartRow = {
  label: string;
  points: ChartPoint[];
};
type PerceptionChartProps = {
  rows: ChartRow[];
  axisLabel: string;
  /** Point key drawn larger, with a ring, to keep the focus brand readable. */
  highlightKey?: string;
  labelWidth?: string;
  compact?: boolean;
};
const TICKS = [1, 2, 3, 4, 5];
function toPercent(value: number): number {
  return (value - 1) / 4 * 100;
}
export function PerceptionChart({
  rows,
  axisLabel,
  highlightKey,
  labelWidth = '30%',
  compact = false
}: PerceptionChartProps) {
  return <div className="flex h-full min-h-0 w-full flex-col" data-id="element-40" data-mp="hpqnp3qqi5f8">
      <div className="flex min-h-0 flex-1 flex-col" data-id="element-41" data-mp="lpr1qn9x8elr">
        {rows.map((row, rowIndex) => <div key={row.label} className="flex min-h-0 flex-1 items-stretch" data-id="element-42" data-mp="2c2ggfi5d98l1" data-mpi={rowIndex}>
            <div className="flex items-center justify-end pr-[3%]" style={{
          width: labelWidth
        }} data-id="element-43" data-mp="2c0c8mp4cjpfh">
              <span className={['text-right font-semibold uppercase tracking-[0.06em] text-ink-soft', compact ? 'text-[clamp(8px,0.85vw,14px)]' : 'text-[clamp(9px,1vw,17px)]'].join(' ')} data-id="element-44" data-mp="2gi8blih9etm4">
                <span className="text-ink-mute" data-id="element-45" data-mp="2larpkgjuzqrg">{rowIndex + 1}. </span>
                {row.label}
              </span>
            </div>
            <div className={['relative flex-1', rowIndex % 2 === 0 ? 'bg-paper-tint' : 'bg-transparent'].join(' ')} data-id="element-46" data-mp="1xm8gvzwwdbyu">
              {TICKS.map(tick => <span key={tick} aria-hidden="true" className="absolute top-0 bottom-0 w-px bg-ink-line" style={{
            left: `${toPercent(tick)}%`
          }} data-id="element-47" data-mp="22jidbzipenw6" />)}
              {row.points.map(point => {
            const isHighlight = point.key === highlightKey;
            return <span key={point.key} className="absolute top-1/2 rounded-full" style={{
              left: `${toPercent(point.value)}%`,
              transform: 'translate(-50%, -50%)',
              width: isHighlight ? 'clamp(11px, 1.35vw, 22px)' : 'clamp(7px, 0.85vw, 14px)',
              height: isHighlight ? 'clamp(11px, 1.35vw, 22px)' : 'clamp(7px, 0.85vw, 14px)',
              background: point.color,
              boxShadow: isHighlight ? '0 0 0 clamp(2px, 0.28vw, 5px) rgba(255,255,255,1)' : 'none'
            }} title={`${point.key}: ${point.value}`} data-id="element-48" data-mp="3q0osxrhbqfo3" />;
          })}
            </div>
          </div>)}
      </div>

      <div className="flex shrink-0" style={{
      paddingLeft: labelWidth
    }} data-id="element-49" data-mp="15o1prmr7emzq">
        <div className="relative flex-1 border-t border-ink/40" data-id="element-50" data-mp="11mq57vn6srye">
          {TICKS.map(tick => <span key={tick} className="absolute top-[0.4vh] text-[clamp(7px,0.8vw,13px)] font-medium text-ink-mute" style={{
          left: `${toPercent(tick)}%`,
          transform: 'translateX(-50%)'
        }} data-id="element-51" data-mp="wmu3k31ypcm0">
              {tick}
            </span>)}
          <p className="pt-[2.4vh] text-center text-[clamp(7px,0.82vw,13px)] font-medium uppercase tracking-[0.12em] text-ink-mute" data-id="element-52" data-mp="hwwc9e8qk6sl">
            {axisLabel}
          </p>
        </div>
      </div>
    </div>;
}